import React, {useEffect, useRef, useState} from "react";
import { useParams } from "react-router-dom";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import DevicesIcon from "@mui/icons-material/Devices";
import PlaceIcon from "@mui/icons-material/Place";
import { useMaterialUIController } from "context";
import isMock from "../../config";
import mapboxgl from "mapbox-gl";

function OrganizationDetails() {
  const { id } = useParams();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [organization, setOrganization] = useState({});
  const textColor = darkMode ? "#fff" : "#000"; // Set text color based on dark mode
  const mapContainerRef = useRef(null);
  const [ lngLat, setLngLat ] = useState(null);
  const mapRef = useRef(null);



  useEffect(() => {
    // Fetch organization data from the API
    const fetchOrganization = async () => {
      try {
        const response = await fetch(`http://localhost:3001/organizations/${id}`);
        const data = await response.json();
        setOrganization(isMock ? data : data.organization);
      } catch (error) {
        console.error("Error fetching organization data: ", error);
      }
    };

    fetchOrganization();
  }, []);

  useEffect(() => {
    if (organization && Object.keys(organization).length > 0) {

      const fetchCoordinates = async () => {
        try {
          const response = await fetch(
              `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                  organization.address
              )}.json?access_token=${mapboxgl.accessToken}`
          );
          const data = await response.json();
          console.log('data:::', data);



          if (data.features && data.features.length > 0) {
            const [longitude, latitude] = data.features[0].center;
            setLngLat({ longitude, latitude });
          }
        } catch (error) {
          console.error("Geocoding error:", error);
        }
      };
      fetchCoordinates();
    }
  }, [organization]);

  // Initialize/flyTo the map
  useEffect(() => {
    if (!lngLat || !mapContainerRef.current) return;

    if (!mapRef.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/satellite-streets-v11",
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });

      new mapboxgl.Marker()
          .setLngLat([lngLat.longitude, lngLat.latitude])
          .addTo(mapRef.current);
    } else {
      mapRef.current.flyTo({
        center: [lngLat.longitude, lngLat.latitude],
        zoom: 15,
      });
    }
    // if (selectedTab === 0) {
    //   // Force map to resize
    //   mapRef.current.resize();
    // }
  }, [lngLat]);


  if (!organization) {
    return <div>Organization not found.</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar name={organization.name}/>
      <div style={{ padding: "20px" }}>
        <Typography variant="h4" gutterBottom style={{ color: textColor }}>
          Organization Details
        </Typography>
        <Grid container spacing={3}>
          {/* Name Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <LocationOnIcon style={{ marginRight: 8 }} /> Name
                </Typography>
                <Typography style={{ color: textColor }}>
                  {organization.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Address Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <PlaceIcon style={{ marginRight: 8 }} /> Address
                </Typography>
                <Typography style={{ color: textColor }}>
                  {organization.address}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Phone Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <PersonIcon style={{ marginRight: 8 }} /> Phone
                </Typography>
                <Typography style={{ color: textColor }}>{organization.phone}</Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Website Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <DevicesIcon style={{ marginRight: 8 }} /> Website
                </Typography>
                <Typography style={{ color: textColor }}>{organization.website}</Typography>

              {/*</Box>*/}
              </CardContent>
            </Card>
          </Grid>

          {/* Type Card */}
          <Grid item xs={12} sm={6} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" style={{ color: textColor }}>
                  <PlaceIcon style={{ marginRight: 8 }} /> Type
                </Typography>
                <Typography style={{ color: textColor }}>-</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>   <Box
          ref={mapContainerRef}
          sx={{
            width: "100%",
            height: "400px",
            mt: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
      />
      </div>
    </DashboardLayout>
  );
}

export default OrganizationDetails;
